import {
    LocalShippingOutlined,
    EventNoteOutlined,
    MapRounded,
    Assessment,
    Hub,
    Settings,
    Person,
    Warehouse,
    FilterList,
    LinkOutlined,
    FiberManualRecord,
    Remove,
    Task,
    AddTask,
    Group,
    Tune,
    AccountCircle,
    Paid,
    Flag,
    Wallet,
    ContactPage,
    ManageAccounts,
    Category,
    CreditCard,
    Gavel,
    WhatsApp,
    LocationOn
} from "@mui/icons-material";


export const FIRST_AND_LAST_MILE_TABS = [
    {
        href: "/merchant",
        icon: Assessment,
        title: "Statistics",
    },
    {
        href: `/merchant/tasks/create`,
        icon: AddTask,
        title: "Create task",
    },
    {
        href: `/merchant/tasks/zone_orders_count?status=UNASSIGNED&shippingCompanyWarehouse=null`,
        icon: Task,
        title: "Unassigned orders",
    },
    // {
    //     href: `/merchant/tasks/zone_orders_count?status=ORDER_ASSIGNED_TO_SHIPPING_COMPANY_FOR_RETURN`,
    //     icon: Task,
    //     title: "ORDER_ASSIGNED_TO_SHIPPING_COMPANY_FOR_RETURN",
    // },
    {
        // href: "/merchant/orders",
        icon: EventNoteOutlined,
        title: "Tasks",
        children: [
            {
                icon: FiberManualRecord,
                iconStyle: { fontSize: 10 },
                listItemIconStyle: { minWidth: 17 },
                title: "Pick up requests",
                href: "/merchant/tasks/zones?status=TASK_CREATED",
            },
            {
                icon: FiberManualRecord,
                iconStyle: { fontSize: 10 },
                listItemIconStyle: { minWidth: 17 },
                title: "Assined for Pickup",
                href: "/merchant/tasks/zones?status=TASK_ASSIGNED_TO_DRIVER_FOR_PICK_UP",
            },
            {
                icon: FiberManualRecord,
                iconStyle: { fontSize: 10 },
                listItemIconStyle: { minWidth: 17 },
                title: "To warehouse",
                href: "/merchant/tasks/zones?status=TASK_PICKED_UP_FROM_MERCHANT",
            },
            {
                title: "In warehouse",
                href: "/merchant/tasks/warehouses?status=IN_SHIPPING_COMPANY_WHAREHOUSE",
                icon: FiberManualRecord,
                iconStyle: { fontSize: 10 },
                listItemIconStyle: { minWidth: 17 },
                noCollapse: false,
                children: [
                    {
                        icon: Remove,
                        iconStyle: { fontSize: 10 },
                        listItemIconStyle: { minWidth: 17 },
                        title: "Rescheduled Orders",
                        href: "/merchant/tasks/warehouses?status=ORDER_RESCHEDULED",
                    },
                    {
                        icon: Remove,
                        iconStyle: { fontSize: 10 },
                        listItemIconStyle: { minWidth: 17 },
                        title: "Assign for transfer",
                        href: "/merchant/tasks/zones?status=TASK_ASSIGNED_TO_DRIVER_FOR_TRANSFER",
                    },
                    // {
                    //     icon: Remove,
                    //     iconStyle: { fontSize: 10 },
                    //     listItemIconStyle: { minWidth: 17 },
                    //     title: "Assign for return",
                    //     href: "/merchant/tasks/zones?status=TASK_ASSIGNED_TO_DRIVER_FOR_RETURN",
                    // },
                    {
                        icon: Remove,
                        iconStyle: { fontSize: 10 },
                        listItemIconStyle: { minWidth: 17 },
                        title: "In Transit",
                        href: "/merchant/tasks/zones?status=TASK_PICKED_UP_FOR_TRANSFER",
                    },
                    {
                        icon: Remove,
                        iconStyle: { fontSize: 10 },
                        listItemIconStyle: { minWidth: 17 },
                        title: "Assign for dropoff",
                        href: "/merchant/tasks/tasks_count?status=TASK_ASSIGNED_TO_DRIVER_FOR_DROP_OFF",
                    },
                ]
            },
            {
                icon: FiberManualRecord,
                iconStyle: { fontSize: 10 },
                listItemIconStyle: { minWidth: 17 },
                title: "Out for delivery",
                href: "/merchant/tasks/zones?status=TASK_PICKED_UP_FOR_DROP_OFF",
            },
            // {
            //     icon: FiberManualRecord,
            //     iconStyle: { fontSize: 10 },
            //     listItemIconStyle: { minWidth: 17 },
            //     title: "Out for return",
            //     href: "/merchant/tasks/zones?status=TASK_PICKED_UP_FOR_RETURN",
            // },
            {
                icon: FiberManualRecord,
                iconStyle: { fontSize: 10 },
                listItemIconStyle: { minWidth: 17 },
                title: "Failed tasks",
                href: "/merchant/tasks/completed?status=TASK_FAILED",
            },
            // {
            //     icon: FiberManualRecord,
            //     iconStyle: { fontSize: 10 },
            //     listItemIconStyle: { minWidth: 17 },
            //     title: "Failed to deliver",
            //     href: `/merchant/tasks/returned`,
            // },
            {
                icon: FiberManualRecord,
                iconStyle: { fontSize: 10 },
                listItemIconStyle: { minWidth: 17 },
                title: "Successful tasks",
                href: "/merchant/tasks/completed?status=TASK_COMPLETED",
            },
            // {
            //     title: "Failed orders",
            //     href: "/merchant/tasks/orders?status=ORDER_FAILED",
            // }
        ]
    },
    {
        href: "/merchant/orders/completed-orders",
        icon: EventNoteOutlined,
        title: "Completed orders",
    },
    {
        href: "/merchant/orders/filter",
        icon: FilterList,
        title: "filterOrders",
    },
    {
        href: "/merchant/tasks/filter",
        icon: FilterList,
        title: "Tasks filter",
    },
    {
        href: "/merchant/warehouse",
        icon: Warehouse,
        title: "Warehouses",

    },
    // {
    //     href: "/merchant/warehouse_guard",
    //     icon: People,
    //     title: "Warehouse supervisors",
    // },
    {
        href: "/merchant/connections",
        icon: Hub,
        title: "Private connections",
    },
    // {
    //     href: "/merchant/shipping-partners",
    //     icon: Hub,
    //     title: "Shipping Partners",
    // },
    {
        href: "/merchant/users",
        icon: Group,
        title: "Users",
    },
    {
        href: "/merchant/drivers",
        icon: LocalShippingOutlined,
        title: "Drivers",
    },
    {
        href: "/merchant/integrations",
        icon: LinkOutlined,
        title: "Integrations",
    },
    {
        href: "/merchant/zones",
        icon: MapRounded,
        title: "Zones",
    },
    {
        icon: Person,
        title: "Account",
        children: [
            {
                href: "/merchant/account/plans",
                icon: Category,
                title: "Plans",
            },
            {
                href: "/merchant/account/subscription",
                icon: CreditCard,
                title: "Subscription",
            },
            {
                href: "/merchant/account/settings",
                icon: ManageAccounts,
                title: "Settings",
            }
        ]
    },
    {
        href: "/merchant/customizations",
        icon: Tune,
        title: "Customizations",
    },
    {
        href: "/merchant/transactions",
        icon: Paid,
        title: "Transactions",
    },
    {
        href: "/merchant/pickup-points",
        icon: Flag,
        title: "Pickup Points",
    },
    {
        href: "/merchant/balance",
        icon: Wallet,
        title: "Wallet Balance",
    },
    {
        icon: WhatsApp,
        title: "Whatsapp Msgs",
        href: "/merchant/settings/whatsapp"
    },
    {
        href: "/terms-and-conditions",
        icon: Gavel,
        title: "Terms and Conditions",
    },
    {
        href: "/merchant/national-address-transactions",
        icon: LocationOn,
        title: "National Address Requests",
    },
]
